import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

import { compose, withHandlers, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_CHANGE_PASSWORD } from 'utils/mixpanel'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import idx from 'idx'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user) || null,
        hasError: idx(state, _ => _.progress.changePassword.hasError) || false,
        errorMessage: idx(state, _ => _.progress.changePassword.error.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onPasswordSubmit: props => (passwordFields) => {
      props.actions.updatePassword(passwordFields.oldPassword, passwordFields.newPassword)
    },
    onBackPress: props => () => {
      props.history.goBack()
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(SCREEN_VIEW_CHANGE_PASSWORD)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/account/ChangePassword/ChangePassword.enhancer.js